//TODO: implement rtf control as standalone component. Currently it is implemented as:
//1) A custom form widget (see FormFieldInput.render / FormFieldInput.rtfEditorLoaded in forms.js)
//2) A custom grid popup in Prepare Content (see QuoteContentGrid.customizeCell in contentGrid.js)

export class RtfLoader extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            visible: false
        };
        // This binding is necessary to make `this` work in the callback
        this.editorLoaded = this.editorLoaded.bind(this);
        this.handleChildEditorLoad = this.handleChildEditorLoad.bind(this);
    }

    handleChildEditorLoad(editor) {
        this.editorLoaded();
        if (this.props.onLoad) {
            this.props.onLoad(editor);
        }
    }

    editorLoaded() {
        this.setState({visible:true});
        if (this.refs.editor && this.refs.editor.scheduleEditorSizeRefresh) {
            this.refs.editor.scheduleEditorSizeRefresh();
        }
        if(this.props.editorLoadedCallback){
            this.props.editorLoadedCallback();
        }
    }

    render() {
        return (
                <div style={this.props.style}>
                    {this.state.visible ? null : <FormPlaceholder message={this.props.message || 'Loading Editor...'} style={{padding:80}} />}
                    <RtfEditor ref="editor" visible={this.state.visible} {...this.props} onLoad={this.handleChildEditorLoad} />
                </div>
        );
    }
}

export class RtfEditor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {  
            rtfId: quosal.util.generateGuid(),
            isDarkMode: $('#dark-toggle[type=checkbox]').prop('checked'),
            iframeName: this.props.name || 'rtfEditorIframe',
        };
        // This binding is necessary to make `this` work in the callback
        this.getEditorContent = this.getEditorContent.bind(this);
        this.disable = this.disable.bind(this);
        this.enable = this.enable.bind(this);
        this.getHtml = this.getHtml.bind(this);
        this.getText = this.getText.bind(this);
        this.setHtml = this.setHtml.bind(this);
        this.setText = this.setText.bind(this);
        this.editorLoaded = this.editorLoaded.bind(this);
        this.darkModeChanged = this.darkModeChanged.bind(this);
        this.postMessageToIframe = this.postMessageToIframe.bind(this);
        this.sendMessageToIframe = this.sendMessageToIframe.bind(this);
        this.refreshEditorSize = this.refreshEditorSize.bind(this);
        this.scheduleEditorSizeRefresh = this.scheduleEditorSizeRefresh.bind(this);
        this.handleEditorMessage = this.handleEditorMessage.bind(this);
        this.handleIframeLoad = this.handleIframeLoad.bind(this);
        this.handleWindowResize = this.handleWindowResize.bind(this);
        this.resizeRefreshTimeoutId = null;
    }

    static getInstance(name) {
        return RtfEditor.instances[name];
    }

    static preload() {
        //This simply ensures that the .aspx page has been hit before being loaded into UI to reduce wait time for AppPool spin up
        $.ajax(quosal.util.url('RtfEditor.aspx'), {
            dataType: 'html',
            success: function(result) {
                //TODO: cache and reuse singleton?
            }
        });
    }
   
    componentDidMount() {
        if (RtfEditor.instances[this.state.iframeName] != null) {
            throw 'Duplicate RtfEditor detected, RtfEditors must have a unique name prop.';
        }

        RtfEditor.instances[this.state.iframeName] = this;

        if (this.props.formField) {
            this.state.lastFieldValue = this.props.formField.props.field.Value
        }
        
        $('#dark-toggle[type=checkbox]').on('change', this.darkModeChanged);

        const iframe = document.getElementById(this.state.iframeName);
        if (iframe) {
            iframe.addEventListener('load', this.handleIframeLoad);
        }
        window.addEventListener('message', this.handleEditorMessage);
        window.addEventListener('resize', this.handleWindowResize);
    }

    componentWillUnmount() {
            delete RtfEditor.instances[this.state.iframeName];
            window.removeEventListener('message', this.handleEditorMessage);
            window.removeEventListener('resize', this.handleWindowResize);
            const iframe = document.getElementById(this.state.iframeName);
            if (iframe) {
                iframe.removeEventListener('load', this.handleIframeLoad);
            }
            if (this.resizeRefreshTimeoutId) {
                window.clearTimeout(this.resizeRefreshTimeoutId);
            }
    }

    getEditorContent() {
        return $(this.refs.input).contents().find('#ASPxHtmlEditor1_DesignIFrame').contents().find('.dxheDesignViewArea_Moderno');
    }

    handleIframeLoad() {
        this.sendMessageToIframe(this.state.isDarkMode);
        this.scheduleEditorSizeRefresh();
    }

    handleEditorMessage(event) {
        if (event.data && event.data.type === 'rtfEditorInit') {
            const iframe = document.getElementById(this.state.iframeName);
            if (iframe && iframe.contentWindow === event.source) {
                this.editorLoaded();
                this.scheduleEditorSizeRefresh();
            }
        }
    }

    handleWindowResize() {
        if (this.resizeRefreshTimeoutId) {
            window.clearTimeout(this.resizeRefreshTimeoutId);
        }
        this.resizeRefreshTimeoutId = window.setTimeout(() => {
            this.refreshEditorSize();
        }, 150);
    }

    darkModeChanged(event) {
        this.setState({ isDarkMode: event.target.checked });
        this.sendMessageToIframe(event.target.checked);
    }

    postMessageToIframe(data) {
        const iframe = document.getElementById(this.state.iframeName);
        if (iframe && iframe.contentWindow) {
            iframe.contentWindow.postMessage(data, '*');
        }
    }

    sendMessageToIframe(isDarkMode) {
        this.postMessageToIframe({ type: 'toggleDarkMode', isDarkMode: isDarkMode });
    }

    refreshEditorSize() {
        const iframe = document.getElementById(this.state.iframeName);
        const height = iframe ? iframe.clientHeight : 0;
        const width = iframe ? iframe.clientWidth : 0;
        this.postMessageToIframe({ type: 'refreshEditorSize', height: height, width: width });
    }

    scheduleEditorSizeRefresh() {
        [0, 50, 150, 400].forEach((ms) => {
            window.setTimeout(() => this.refreshEditorSize(), ms);
        });
    }

    disable() {
        var content = this.getEditorContent();
        content.removeAttr('contenteditable');
        $(this.refs.input).contents().find('#ASPxHtmlEditor1_TBRow').hide();
        $(this.refs.input).contents().find('#ASPxHtmlEditor1_SBarCell').hide();
    }

    enable() {
        var content = this.getEditorContent();
        content.attr('contenteditable', true);
        $(this.refs.input).contents().find('#ASPxHtmlEditor1_TBRow').show();
        $(this.refs.input).contents().find('#ASPxHtmlEditor1_SBarCell').show();
    }

    getHtml() {
        var container = $(this.refs.input).contents().find('#rtfNoteHtmlContainer')[0];
        var plainText = container ? container.innerHTML : "";

        return plainText;
    }

    getText() {
        return $(this.getEditorContent()).text();
    }

    setHtml(html, suppressChangeEvent) {
        if (this.state.isLoaded) {
            var content = this.getEditorContent();

            if (!html && this.htmlUpdate) {
                html = this.htmlUpdate.content;
            }

            if (suppressChangeEvent == null && this.htmlUpdate) {
                suppressChangeEvent = this.htmlUpdate.suppressChangeEvent;
            }

            content.html(html);
            // #9421632 SM - Automatically added notes not saving because RTF container is not created
            if ($(this.refs.input).contents().find('#rtfNoteHtmlContainer')) {
                $(this.refs.input).contents().find('#rtfNoteHtmlContainer')[0].innerHTML = html;
            }

            if (this.htmlUpdate) {            
                delete this.htmlUpdate;
            }

            if (!suppressChangeEvent && this.props.onChange) {
                this.props.onChange();
            }
        } else {
            this.htmlUpdate = {
                content: html,
                suppressChangeEvent: suppressChangeEvent
            };
        }
    }

    setText(text, suppressChangeEvent) {
        $(this.getEditorContent()).text(text);

        if (!suppressChangeEvent && this.props.onChange) {
            this.props.onChange();
        }
    }

    editorLoaded() {
        if (this.state.isLoaded) {
            return;
        }

        this.state.isLoaded = true;

        if (this.htmlUpdate) {
            this.setHtml();
        }

        if (this.props.onChange || this.props.applyChangedContent) {
            // var content = this.getEditorContent();

            var callback = function() {
                if (this.props.onChange) {
                    this.props.onChange.call(this);
                } else if (this.props.applyChangedContent) {
                    this.props.applyChangedContent(this.getHtml());
                }
            }.bind(this);

            if (this.props.disabled) {
                //this.disable();
                //content.removeAttr('contenteditable');
                //$(this.refs.input).contents().find('#ASPxHtmlEditor1_TBRow').hide();
                //$(this.refs.input).contents().find('#ASPxHtmlEditor1_SBarCell').hide();
            } else {
                // FSP 8/17/16: This element doesn't actually have any organically valid 'change' event--in fact it's a
                // <table> element. But adding this event hook lets us access the callback from ASP.Net's javascript
                // event system for the editor by finding this element and calling .change() on it.
                $(this.refs.input).contents().find('#ASPxHtmlEditor1').change(callback);
            }
            if (this.props.callOnChangeImmediately) {
                callback();
            }
        }

        if (this.props.onLoad) {
            this.props.onLoad(this);
        }

        this.scheduleEditorSizeRefresh();
    }

    render() {
        if (this.props.formField && this.props.formField.props.field) {
            if (this.state.lastFieldValue !== undefined && this.state.lastFieldValue != this.props.formField.props.field.Value) {
                this.setHtml(this.props.formField.props.field.Value, true);
            }

            this.state.lastFieldValue = this.props.formField.props.field.Value;
        }

        if (this.props.disabled) {
            this.disable();
        } else {
            this.enable();
        }

        var style = this.props.style ? quosal.util.clone(this.props.style) : {width:'100%', minHeight:650};

        // FSP 7/12/16 8135435: I'm leaving the below commented line as documentation of a strange bug and a reminder not to add it back.
        // The editor did not load correctly (just for IE) when this display=none style was used here. The cosmetic consequence
        // of not using this style is not a very big deal--the outline of an empty box appears a little earlier than it would otherwise.
        // if(this.props.visible === false) style.display = 'none';

        var url = this.props.url + '&rtfid=' + this.state.rtfId;

        return (
            <iframe ref="input" style={style}  id={this.state.iframeName}  name={this.state.iframeName} src={url} frameBorder="0" seamless></iframe>
        );
    }
}

RtfEditor.instances= [];